import React from "react";
import { CircleCheckBig, RotateCcw } from "lucide-react";
import LeftIconButton from "../../../../components/UI/buttonUI/LeftIconButton";

export const AllSitesUpToDate = () => {
  return (
    <div className="bg-white rounded-xl shadow-sm border mt-2 h-[calc(100vh-13em)] max-lg:h-[calc(100vh-12em)] max-md:h-[calc(100vh-13em)] overflow-auto flex items-center justify-center">
      <div className="flex flex-col items-center text-center">
        {/* Icon Circle */}

        <CircleCheckBig className="text-[#1a7a4a]" size={35} />

        {/* Title */}
        <h2 className="mt-2 font-figtreeBold text-lg text-primary">
          All sites are up to date!
        </h2>

        {/* Subtitle */}
        <p className="mt-2 mb-3 text-xs text-gray-500 max-w-md leading-relaxed">
          Every site has been visited within the last 30 days. <br />
          Great work keeping the field operations on track.
        </p>
        <LeftIconButton
          text="Refresh Data"
          btnStyle="text-dark-blue bg-gray-200 hover:bg-gray-100 max-lg:text-xs border border-gray-300"
          Icon={RotateCcw}
          iconStyle="max-lg:w-4"
          size={18}
          onClick={() => window.location.reload()}
        />
      </div>
    </div>
  );
};
